/** 草图关系兼容层使用的实体类型常量。 */
export const SketchEntityKind = {
    /** 草图点。 */
    Point: 'Point',
    /** 草图端点。 */
    EndPoint: 'EndPoint',
    /** 草图直线。 */
    Line: 'Line',
    /** 草图中心线。 */
    CenterLine: 'CenterLine',
    /** 草图圆弧。 */
    Arc: 'Arc',
    /** 草图圆。 */
    Circle: 'Circle',
    /** 草图椭圆。 */
    Ellipse: 'Ellipse',
    /** 草图抛物线。 */
    Parabola: 'Parabola',
    /** 草图样条曲线。 */
    Spline: 'Spline',
    /** 草图槽口。 */
    Slot: 'Slot',
    /** 参考平面。 */
    ReferencePlane: 'ReferencePlane',
    /** 实体平面面。 */
    PlanarFace: 'PlanarFace',
    /** 实体曲面面。 */
    SurfaceFace: 'SurfaceFace',
    /** 实体边。 */
    ModelEdge: 'ModelEdge',
    /** 参考轴。 */
    ReferenceAxis: 'ReferenceAxis',
    /** 草图复合集合。 */
    Collection: 'Collection',
} as const;

/** 草图关系兼容层使用的实体类型。 */
export type SketchEntityKind = typeof SketchEntityKind[keyof typeof SketchEntityKind];
